import { Input as _Input } from 'ant-design-vue'
_Input.install = (Vue) => {
  Vue.component(_Input.name, _Input)
}
export default _Input
